export default __webpack_public_path__ + "static/howto-home2-9f308c1ddbbccd3de8014ddb1ced1ed1.svg";